module.exports = __webpack_public_path__ + "static/media/DeclaracionJurada.6aa58abf.png";